import classNames from "classnames";
import "./InputWrapper.scss";
import React from "react";

export const InputWrapper: React.FC<{ children: any; className?: any }> = ({ children, className }) => {
    const classes = classNames("input-wrapper-component", className);

    return <div className={classes}>{children}</div>;
};
